export const kgkmTabledataDummy = [
  {
    S_N: 1,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 1,
    toKG: 50,
    fromKMS: 1,
    toKMS: 500,
    rate: 4,
    docCharge: 4,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 2,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 1,
    toKG: 50,
    fromKMS: 501,
    toKMS: 1000,
    rate: 5,
    docCharge: 5,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 3,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 1,
    toKG: 50,
    fromKMS: 1001,
    toKMS: 1500,
    rate: 6,
    docCharge: 6,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 4,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 1,
    toKG: 50,
    fromKMS: 1501,
    toKMS: 2000,
    rate: 7,
    docCharge: 7,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 5,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 51,
    toKG: 100,
    fromKMS: 1,
    toKMS: 500,
    rate: 4,
    docCharge: 4,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 6,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 51,
    toKG: 100,
    fromKMS: 501,
    toKMS: 1000,
    rate: 5,
    docCharge: 5,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 7,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 51,
    toKG: 100,
    fromKMS: 1001,
    toKMS: 1500,
    rate: 6,
    docCharge: 6,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 8,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 51,
    toKG: 100,
    fromKMS: 1501,
    toKMS: 2000,
    rate: 7,
    docCharge: 7,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 9,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 101,
    toKG: 500,
    fromKMS: 1,
    toKMS: 500,
    rate: 4,
    docCharge: 4,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    S_N: 10,
    serviceTypeID: 2345,
    serviceType: 'By Bus',
    consignmentID: 12345,
    consignmentType: 'Bag',
    fromKG: 101,
    toKG: 500,
    fromKMS: 501,
    toKMS: 1000,
    rate: 5,
    docCharge: 5,
    action: 'Edit',
    modifiedBy: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
]
export const ratematrixFileDataDummy = [
  {
    sN: 1,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 1,
    toKm: 500,
    rate: 100.0,
    docCharge: 100.0,
  },
  {
    sN: 2,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 90.0,
    docCharge: 90.0,
  },
  {
    sN: 3,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 80.0,
    docCharge: 80.0,
  },
  {
    sN: 4,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 70.0,
    docCharge: 70.0,
  },
  {
    sN: 5,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 60.0,
    docCharge: 60.0,
  },
  {
    sN: 6,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 50.0,
    docCharge: 50.0,
  },
  {
    sN: 7,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 40.0,
    docCharge: 40.0,
  },
  {
    sN: 8,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 30.0,
    docCharge: 30.0,
  },
  {
    sN: 9,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 1001,
    toKg: 2000,
    fromKm: 501,
    toKm: 1000,
    rate: 20.0,
    docCharge: 20.0,
  },
  {
    sN: 10,
    chargeTypeId: 23456,
    consignmentTypeId: 123456,
    fromKg: 5001,
    toKg: 10000,
    fromKm: 501,
    toKm: 1000,
    rate: 3.0,
    docCharge: 3.0,
  },
]
export const ratematrxiHistoryDataDummy = [
  {
    sN: 1,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 1,
    toKg: 50,
    fromKms: 1,
    toKms: 500,
    oldRate: 4,
    newRate: 4,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 2,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 1,
    toKg: 50,
    fromKms: 501,
    toKms: 1000,
    oldRate: 5,
    newRate: 5,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 3,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 1,
    toKg: 50,
    fromKms: 1001,
    toKms: 1500,
    oldRate: 6,
    newRate: 6,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 4,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 1,
    toKg: 50,
    fromKms: 1501,
    toKms: 2000,
    oldRate: 7,
    newRate: 7,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 5,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 51,
    toKg: 100,
    fromKms: 1,
    toKms: 500,
    oldRate: 4,
    newRate: 4,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 6,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 51,
    toKg: 100,
    fromKms: 501,
    toKms: 1000,
    oldRate: 5,
    newRate: 5,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 7,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 51,
    toKg: 100,
    fromKms: 1001,
    toKms: 1500,
    oldRate: 6,
    newRate: 6,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 8,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 51,
    toKg: 100,
    fromKms: 1501,
    toKms: 2000,
    oldRate: 7,
    newRate: 7,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 9,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 101,
    toKg: 500,
    fromKms: 1,
    toKms: 500,
    oldRate: 4,
    newRate: 4,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
  {
    sN: 10,
    serviceTypeId: 2345,
    serviceType: 'By Bus',
    consignmentId: 12345,
    consignmentType: 'Bag',
    fromKg: 101,
    toKg: 500,
    fromKms: 501,
    toKms: 1000,
    oldRate: 5,
    newRate: 5,
    oldDocCharge: 4,
    newDocCharge: 4,
    modifiedByUser: 'Krishna Pandey',
    modTimeAndDate: '09:30 23-Nov-23',
  },
]
export const standardRateHistoryDataDummy = [
  {
    sN: 1,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 123,
    destCity: 'Baroda',
    distanceInKms: 100,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 2,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 234,
    destCity: 'Surat',
    distanceInKms: 270,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 3,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 567,
    destCity: 'Rajkot',
    distanceInKms: 200,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 4,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 789,
    destCity: 'Udaipur',
    distanceInKms: 260,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 5,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 890,
    destCity: 'Jaipur',
    distanceInKms: 600,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 6,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 234,
    destCity: 'Surat',
    distanceInKms: 270,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 7,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 567,
    destCity: 'Rajkot',
    distanceInKms: 200,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 8,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 789,
    destCity: 'Udaipur',
    distanceInKms: 260,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 9,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 890,
    destCity: 'Jaipur',
    distanceInKms: 600,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  },
  {
    sN: 10,
    sourceCityId: 100,
    sourceCity: 'Ahmedabad',
    destCityId: 901,
    destCity: 'Gurgaon',
    distanceInKms: 840,
    byBus: '3(Per Kg)',
    byCargo: '0.05 (Per KG-KM)',
    byExpressCargo: '3(Per Kg)',
    byPartnerCargo: '0.05 (Per KG-KM)',
    modifiedBy: 'Kirtan Pandey',
    modifiedTimeAndDate: '09:30 23-Nov-23'
  }
];

export  const dataDummyRateMatrix = [
  {
    serviceType: 'By Bus',
    freightCharges: 100,
    freightChargesType: 0,
    collectionCartage: 25,
    collectionCartageType: 0,
    delCartageOnBooking: 35,
    delCartageOnBookingType: 0,
    documentCharges: 15,
    documentChargesType: 0,
    hamaliCharge: 20,
    hamaliChargeType: 0,
    oprHamaliCharge: 10,
    oprHamaliChargeType: 1,
    pickupCharge: 15,
    pickupChargeType: 0,
    dropOffCharge: 10,
    dropOffChargeType: 0,
    docCharge: 5,
    docChargeType: 0,
    valuationAmount: 500,
    valuationAmountType: 0,
    conversionFees: 20,
    conversionFeesType: 0,
    delHamaliCharges: 30,
    delHamaliChargesType: 0,
    deliveryOprHamChrgs: 20,
    deliveryOprHamChrgsType: 0,
    delCartageOnDel: 40,
    delCartageOnDelType: 0,
    demurrageCharges: 50,
    demurrageChargesType: 1,
  },
  {
    serviceType: 'By Cargo',
    freightCharges: 200,
    freightChargesType: 1,
    collectionCartage: 50,
    collectionCartageType: 0,
    delCartageOnBooking: 70,
    delCartageOnBookingType: 1,
    documentCharges: 30,
    documentChargesType: 1,
    hamaliCharge: 40,
    hamaliChargeType: 0,
    oprHamaliCharge: 20,
    oprHamaliChargeType: 1,
    pickupCharge: 30,
    pickupChargeType: 0,
    dropOffCharge: 20,
    dropOffChargeType: 1,
    docCharge: 10,
    docChargeType: 0,
    valuationAmount: 1000,
    valuationAmountType: 1,
    conversionFees: 40,
    conversionFeesType: 0,
    delHamaliCharges: 60,
    delHamaliChargesType: 1,
    deliveryOprHamChrgs: 40,
    deliveryOprHamChrgsType: 0,
    delCartageOnDel: 80,
    delCartageOnDelType: 1,
    demurrageCharges: 100,
    demurrateChargesType: 0,
  },
  {
    serviceType: 'By Express Cargo',
    freightCharges: 300,
    freightChargesType: 0,
    collectionCartage: 75,
    collectionCartageType: 0,
    delCartageOnBooking: 105,
    delCartageOnBookingType: 0,
    documentCharges: 45,
    documentChargesType: 0,
    hamaliCharge: 60,
    hamaliChargeType: 1,
    oprHamaliCharge: 30,
    oprHamaliChargeType: 0,
    pickupCharge: 45,
    pickupChargeType: 1,
    dropOffCharge: 30,
    dropOffChargeType: 0,
    docCharge: 15,
    docChargeType: 1,
    valuationAmount: 1500,
    valuationAmountType: 0,
    conversionFees: 60,
    conversionFeesType: 1,
    delHamaliCharges: 90,
    delHamaliChargesType: 0,
    deliveryOprHamChrgs: 60,
    deliveryOprHamChrgsType: 1,
    delCartageOnDel: 120,
    delCartageOnDelType: 0,
    demurrageCharges: 150,
    demurrageChargesType: 1,
  },
  {
    serviceType: 'By Partner Cargo',
    freightCharges: 400,
    freightChargesType: 1,
    collectionCartage: 100,
    collectionCartageType: 0,
    delCartageOnBooking: 140,
    delCartageOnBookingType: 1,
    documentCharges: 60,
    documentChargesType: 1,
    hamaliCharge: 80,
    hamaliChargeType: 0,
    oprHamaliCharge: 40,
    oprHamaliChargeType: 1,
    pickupCharge: 60,
    pickupChargeType: 0,
    dropOffCharge: 40,
    dropOffChargeType: 1,
    docCharge: 20,
    docChargeType: 0,
    valuationAmount: 2000,
    valuationAmountType: 0,
    conversionFees: 80,
    conversionFeesType: 1,
    delHamaliCharges: 120,
    delHamaliChargesType: 1,
    deliveryOprHamChrgs: 80,
    deliveryOprHamChrgsType: 0,
    delCartageOnDel: 160,
    delCartageOnDelType: 1,
    demurrageCharges: 200,
    demurrageChargesType: 0,
  },
]
export const dataDummyRateCrossing = [
  {
    sN: 1,
    fileName: 'Rate Master 22-08-2023.csv',
    status: 'Pending',
    requestedDate: '09:30 23-Nov-23',
    requestedBy: 'Kirtan Pandya',
    cancelledDateTime: 'NA',
    cancelledByUser: 'NA',
    cancelledRemark: 'NA',
    action: 'CancelActive',
  },
  {
    sN: 2,
    fileName: 'Rate Master 22-08-2023_v2.csv',
    status: 'In Progress',
    requestedDate: '10:30 23-Nov-23',
    requestedBy: 'Kirtan Pandya',
    cancelledDateTime: 'NA',
    cancelledByUser: 'NA',
    cancelledRemark: 'NA',
    action: 'CancelActive',
  },
  {
    sN: 3,
    fileName: 'Rate Master 22-08-2023_v3.csv',
    status: 'Completed',
    requestedDate: '11:30 23-Nov-23',
    requestedBy: 'Kirtan Pandya',
    cancelledDateTime: 'NA',
    cancelledByUser: 'NA',
    cancelledRemark: 'NA',
    action: 'CancelActive',
  },
  {
    sN: 4,
    fileName: 'Rate Master 22-08-2023_v4.csv',
    status: 'Cancelled',
    requestedDate: '12:30 23-Nov-23',
    requestedBy: 'Kirtan Pandya',
    cancelledDateTime: '12:30 23-Nov-23',
    cancelledByUser: 'Kirtan Pandya',
    cancelledRemark: 'File is corrupted',
    action: 'Cancel',
  },
]


export const dataDummybranchWiseRate = [
  {
    destinationCityName: 'Bangalore',
    byBus: 10,
    normalCargo: 11,
    expressCargo: 12,
    partnerRate: 13,
    billingUnit: 'Per KG-KM',
    isCity:true
  },
  {
    destinationCityName: 'Maven Ops Bangalore',
    byBus: 10,
    normalCargo: 11,
    expressCargo: 12,
    partnerRate: 13,
    billingUnit: 'Per KG-KM',
    isCity:false
  },
  {
    destinationCityName: 'Maven Ops HO SK Travels',
    byBus: 12,
    normalCargo: 13,
    expressCargo: 14,
    partnerRate: 15,
    billingUnit: 'Per KG-KM',
    isCity:false
  },
  {
    destinationCityName: 'Ahmedabad',
    byBus: 10,
    normalCargo: 11,
    expressCargo: 12,
    partnerRate: 13,
    billingUnit: 'Per KG-KM',
    isCity:true
  },
  {
    destinationCityName: 'Maven Ops Ahmedabad',
    byBus: 10,
    normalCargo: 11,
    expressCargo: 12,
    partnerRate: 13,
    billingUnit: 'Per KG-KM',
    isCity:false
  },
  {
    destinationCityName: 'Maven Ops Mansi Circle',
    byBus: 12,
    normalCargo: 13,
    expressCargo: 14,
    partnerRate: 15,
    billingUnit: 'Per KG-KM',
    isCity:false
  },
  {
    destinationCityName: 'Jaipur',
    byBus: 10,
    normalCargo: 11,
    expressCargo: 12,
    partnerRate: 13,
    billingUnit: 'Per KG-KM',
    isCity:true
  },
  {
    destinationCityName: 'Maven Ops Sanganer',
    byBus: 10,
    normalCargo: 11,
    expressCargo: 12,
    partnerRate: 13,
    billingUnit: 'Per KG-KM',
    isCity:false
  },
  {
    destinationCityName: 'Delhi',
    byBus: 9,
    normalCargo: 9,
    expressCargo: 9,
    partnerRate: 9,
    billingUnit: 'Per KG-KM',
    isCity:true
  },
  {
    destinationCityName: 'Maven Ops Roshnara',
    byBus: 9,
    normalCargo: 9,
    expressCargo: 9,
    partnerRate: 9,
    billingUnit: 'Per KG-KM',
    isCity:false
  },
  {
    destinationCityName: 'Maven Ops Karol Baug',
    byBus: 10,
    normalCargo: 10,
    expressCargo: 10,
    partnerRate: 10,
    billingUnit: 'Per KG-KM',
    isCity:false
  },
]